import React from "react";
import { forwardRef } from "react";
import "../styles/OurTeam.css";

import Logo_pic from "../assets/team_img/logo_pic.jpg"


import Nitesh_pic from "../assets/team_img/Nitesh_kumar_pandey.jpg"
import Hitesh_pic from "../assets/team_img/Hitesh.jpg"
import Naman_pic from "../assets/team_img/Naman.jpg"
import Mithul_pic from "../assets/team_img/Mithul_kalal.jpg"
import Kushal_pic from "../assets/team_img/Kushal_Mahawar.jpg"


import Jayendra_choudhary_pic from "../assets/team_img/Jayendra_choudhary.jpg"
import Mohit_sharma_pic from "../assets/team_img/Mohit_Sharma.jpg"
import Sahil_pic from "../assets/team_img/Sahil_suma.jpg"
import Kartik_pic from "../assets/team_img/Kartik.jpg"
import Yash_pic from "../assets/team_img/Yash_kumar.jpg"
import Mridu_pic from "../assets/team_img/Mridu.jpg"
import Vaishali_pic from "../assets/team_img/vaishali_upadhyay.jpg"
import Raunak_pic from "../assets/team_img/Raunak_bansal.jpg"
import Vanshika_pic from "../assets/team_img/Vanshika_Goyal.jpg"
import Tanya_pic from "../assets/team_img/Tanya.jpg"
import Rudra_pic from "../assets/team_img/Rudra_pratap.jpg"
import Neeshu_pic from "../assets/team_img/Neeshu.png"
import Jayprakash_pic from "../assets/team_img/Jayprakash.jpg"
import Pankaj_pic from "../assets/team_img/Pankaj.png"

const Judges = forwardRef((props, ref) => {
  const org_team = [
    { name: "Naman Soni", desig: "Qrganizing Committee Head", pic: Naman_pic, num: "tel:+91 9664464843" },
    { name: "Kushal Mahawar", desig: "Social Media Head", pic: Kushal_pic, num: "tel:+91 6367828788" },
    { name: "Nitesh Kumar Pandey", desig: "Technical Head", pic: Nitesh_pic, num: "tel:+91 7061474588" },
    { name: "Mithul Kalal", desig: "Marketing Head", pic: Mithul_pic, num: "tel:+91 7726066155" },
    { name: "Hitesh Kumar Sharma", desig: "Hospitality Head", pic: Hitesh_pic, num: "tel:+91 9667442138" },
  ];

  const core_team = [
    { name: "Jayendra choudhary", desig: "Cyber Security", pic: Jayendra_choudhary_pic },
    { name: "Mohit Sharma", desig: "Cyber Security", pic: Mohit_sharma_pic },
    { name: "Sahil Suman", desig: "CSE", pic: Sahil_pic },
    { name: "Kartik Rathore", desig: "CSE", pic: Kartik_pic },
    { name: "Yash Kumar", desig: "CSE", pic: Yash_pic },
    { name: "Mridu Saraf", desig: "CSE", pic: Mridu_pic },
    { name: "Vaishali Upadhyay", desig: "AI", pic: Vaishali_pic },
    { name: "Raunak Bansal", desig: "CSE", pic: Raunak_pic },
    { name: "Vanshika Goyal", desig: "CSE", pic: Vanshika_pic },
    { name: "Tanya Rathore", desig: "AI", pic: Tanya_pic },
    { name: "Rudra Pratap Yadav", desig: "CSE", pic: Rudra_pic },
    { name: "Neeshu Yadav", desig: "CSE", pic: Neeshu_pic },
    { name: "Jayprakash Rajput", desig: "CSE", pic: Jayprakash_pic },
    { name: "Pankaj Kumawat", desig: "CSE", pic: Pankaj_pic },
  ];
  return (
    <section ref={ref} className="team-div1">

      <div className="main-background1">
        <source className="main_bg_cont1" />
      </div>

    <div>
      <h1 className="org-team-head">Organizing Team</h1>
    </div>
    <article className="org-team-card-div">
      {org_team.map((org_team, index) => (
        <div className="org-team-card">
          <div className="team-card__hero">
            <header className="team-card__hero-header">
              <img src={org_team.pic} alt="Team Member Pic"></img>
            </header>
          </div>

          <footer className="team-card__footer">
            <div className="team-card__job-summary">
              <div className="team-card__job">
                <div key={index} className="judge-team-card">
                  <h2 className="team-card__job-title">{org_team.name}</h2>
                  <p className="team-card__designation">{org_team.desig}</p>
                </div>
              </div>
            </div>
            <a href={org_team.num} className="team-card__btn">
              <span class="material-symbols-outlined">
                call
              </span>
            </a>
          </footer>
        </div>
      ))}
    </article>

      <></>
      <></>


    <div>
      <h1 className="core-team-head">Core Team</h1>
    </div>
    <article className="org-team-card-div">
      {core_team.map((core_team, index) => (
        <div className="org-team-card">
          <div className="team-card__hero">
            <header className="team-card__hero-header">
              <img src={core_team.pic} alt="Team Member Pic"></img>
            </header>
          </div>

          <footer className="core-card__footer">
            <div className="team-card__job-summary">
              <div className="team-card__job">
                <div key={index} className="judge-team-card">
                  <h2 className="core-card__job-title">{core_team.name}</h2>
                  <p className="team-card__designation">{core_team.desig}</p>
                </div>
              </div>
            </div>
          </footer>
        </div>
      ))}
    </article>


    </section>
  );
});

export default Judges;
